



















































































































































import helpers from '../../helpers'
import './VideoPlayer.scss'
import ChromaKey from '@/components/ChromaKey'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import { ChromaKeyPreviewQualityType } from '../../types/users'
import { CastStream } from '@/types/streams'
import VideoObject from '@/classes/VideoObject'
import { defineComponent } from '@vue/composition-api'
import { ChromaKey as ChromaKeyClass } from '@/modules/user/classes'
import { releaseVideo } from '@/modules/video/utils/VideoManagementUtils'

export default defineComponent({
  name: 'VideoPlayer',
  emits: {
    onDisable () { return true }
  },
  props: {
    streamSrc: {
      type: Object as () => CastStream|VideoObject|null|undefined,
      required: false,
      default: null
    },
    chromakey: {
      type: Object as () => ChromaKeyClass,
      default: null,
    },
    pickingMode: {
      type: Boolean,
      default: false
    },
    debugMode: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: true,
    },
    videoId: {
      type: String as () => string|null,
      required: false,
      default: null
    },
    fullres: {
      type: Boolean,
      required: false,
      default: false
    },
    hideVideo: {
      type: Boolean,
      required: false,
      default: false
    },
    showLoader: {
      type: Boolean,
      required: false,
      default: false
    },
    QAId: {
      type: String,
      required: false,
      default: ''
    },
    enableControls: {
      type: Boolean,
      required: false,
      default: false
    },
    enableDefaultControls: {
      type: Boolean as () => boolean|null,
      required: false,
      default: null
    },
    enableDisableButton: {
      type: Boolean,
      required: false,
      default: false
    },
    enableFastStreamSwitching: {
      type: Boolean,
      required: false,
      default: true
    },
    isPlaying: {
      type: Boolean,
      required: false,
      default: true
    },
    externalUrl: {
      type: String as () => string|null,
      required: false,
      default: null
    }
  },
  data: () => ({
    oldMediaStream: null as MediaStream|null,
    newMediaStream: null as MediaStream|null,
    randStr: null as null|string,
    disabled: false,
    playInterval: null as number|null
  }),
  computed: {
    controls (): boolean|null {
      return this.enableDefaultControls ? true : null
    },
    chromaKeyEnabled (): boolean {
      if (this.chromakey && this.chromakey.enabled)
        if (this.fullres)
          return true
        else
          return this.$store.direct.state.user.profile?.chromaKeyPreviewQuality !== ChromaKeyPreviewQualityType.Off
      else
        return false
    },
    currentMediaStream (): MediaStream|null {
      return this.streamSrc?.srcObject ?? null
    },
    randStrVid (): string {
      if (this.videoId) {
        return this.videoId
      } else {
        return 'vid' + this.randStr
      }
    },
    elVideo (): HTMLVideoElement|undefined {
      const video = this.$refs.video as HTMLVideoElement|undefined
      return video ?? undefined
    },
    oldElVideo (): HTMLVideoElement|undefined {
      const video = this.$refs.videoOld as HTMLVideoElement|undefined
      return video ?? undefined
    }
  },
  watch: {
    currentMediaStream: {
      immediate: true,
      handler (newVal: MediaStream|null|undefined, oldVal: MediaStream|null|undefined) {
        if (!this.enableFastStreamSwitching) {
          this.oldMediaStream = newVal ?? null
          return
        }
        this.oldMediaStream = oldVal ?? newVal ?? null
        if (!newVal) return
        setTimeout(() => {
          this.newMediaStream = newVal ?? null
          this.startAutoplay()
        }, 5000)
      }
    }
  },
  created () {
    this.randStr = helpers.makeId()
    this.playInterval = window.setInterval(() => {
      this.startAutoplay()
    }, 100)
  },
  beforeDestroy () {
    this.clearIntervalAutoplay()
    releaseVideo(this.elVideo)
    releaseVideo(this.oldElVideo)
    if (this.elVideo) {
      this.elVideo.pause()
      this.elVideo.srcObject = null
      this.elVideo.load()
    }
    if (this.oldElVideo) {
      this.oldElVideo.pause()
      this.oldElVideo.srcObject = null
      this.oldElVideo.load()
    }
  },
  methods: {
    startAutoplay () {
      const video = this.$refs.video as HTMLVideoElement|undefined
      if (video === undefined) return
      video.play().catch((error) => console.warn('Warning while playing video', error))
      this.clearIntervalAutoplay()
    },
    clearIntervalAutoplay () {
      if (this.playInterval === null) return
      window.clearInterval(this.playInterval)
      this.playInterval = null
    },
    colorPicked (pixel: string) {
      this.$emit('colorPicked', pixel)
    },
    toggleMuteState () {
      this.$emit('onMute', !this.muted)
    },
    disableStream () {
      this.$emit('onDisable')
    },
    play (event: Event) {
      this.$emit('onPlay', event, this.streamSrc)
    }
  },
  components: {
    ChromaKey,
    ClipLoader
  }
})
